import { render, staticRenderFns } from "./SelectMoreGenres.vue?vue&type=template&id=1c3e3ae0&"
import script from "./SelectMoreGenres.vue?vue&type=script&lang=ts&"
export * from "./SelectMoreGenres.vue?vue&type=script&lang=ts&"
import style0 from "./SelectMoreGenres.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports